import AuthModel from './AuthModel'
import axios from 'axios'
import config from 'react-observable-store'
import moment from 'moment'
import FileSaver from 'file-saver'

/**
 * Docs model
 *
 * Responsible to comunicate with remote server
 * @type {String}
 */
const DocsModel = {

    /**
     * Server endpoint
     * @type {String}
     */
     endpoint: () => {
         return config.get('globals').server.endpoint + '/docs'
     },

    /**
     * Get HTTP options
     * @return {object}
     */
    getOptions: () => {
        return {
            headers: {
                'X-Authorization': AuthModel.getAuthToken()
            }
        }
    },

    /**
     * Download file
     * @param  {String} filename The file name
     * @param  {[type]} url      The download url
     * @param  {[type]} type     mime type
     * @return {null}            Async return
     */
    download: (filename, url, type, cb) => {
        var reqOptions = {
            responseType: 'arraybuffer',
            headers: {
                'X-Authorization': AuthModel.getAuthToken()
            }
        }
        axios.get(url, reqOptions)
        .then(res => {
            if (res.status === 200) {
                var blob = new Blob([res.data], {type: type})
                FileSaver.saveAs(blob, filename)
            } else {
                console.log('error downloading status: ', res.status)
            }
        })
        .catch((error) => {
            console.log(error)
        })
    },

    /**
     * Dispense a new record
     * @return {object} The new record as object
     */
    dispense: () => {
        return {
            id: '',
            title: '',
            description: '',
            attachments: [],
            data: moment().format('YYYY/MM/DD'),
            type_id: 1,
            filename: '',
            mime: ''
        }
    },

    /**
     * Find all docs
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    findAll: (cb) => {
        return axios.get(DocsModel.endpoint() + '/all', DocsModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb([])
        })
        .catch((error) => {
            cb([])
        })
    },

    /**
     * Find user own docs
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    findOwn: (cb) => {
        if (!AuthModel.isAuthenticated()) return cb([])
        return axios.get(DocsModel.endpoint(), DocsModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb([])
        })
        .catch((error) => {
            cb([])
        })
    },

    /**
     * Find record
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    find: (id, cb) => {
        return axios.get(DocsModel.endpoint() + '/' + id, DocsModel.getOptions())
        .then(res => {
            if (res.status === 200) {
                cb(res.data)
            } else cb({})
        })
        .catch((error) => {
            cb({})
        })
    },

    /**
     * Store record
     * @param  {object}   item The record to store
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    store: (item, cb) => {

        // Filter fields to store
        var endpoint = DocsModel.endpoint(), formData = {}
        const fields = Object.keys(DocsModel.dispense())
        for (var i = 0; i < fields.length; i++) {
            formData[fields[i]] = item[fields[i]]
        }
        axios.post(endpoint, formData, DocsModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb({})
        })
    },

    /**
     * Upload file to import
     * @param  {object}   item The record to store
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    upload: (item, cb) => {
        axios.post(DocsModel.endpoint() + '/upload', item, DocsModel.getOptions())
        .then(res => {
            res.status === 200 ? cb(res.data) : cb({})
        })
    },

    /**
     * Remove record
     * @param  {object}   item The record to be removed
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    remove: (item, cb) => {
        axios.delete(DocsModel.endpoint() + '/' + item.id, DocsModel.getOptions())
        .then(res => {
            cb()
        })
    },

    /**
     * Remove upload
     * @param  {object}   item The record to be removed
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    removeUpload: (item, cb) => {
        axios.delete(DocsModel.endpoint() + '/upload/' + item.id, DocsModel.getOptions())
        .then(res => {
            cb()
        })
    },

    /**
     * Remove temporary upload
     * @param  {object}   filename The filename to be removed
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    removeTempUpload: (item, cb) => {
        const url = DocsModel.endpoint() + '/tempupload/' + item.name
        axios.delete(url, DocsModel.getOptions())
        .then(res => {
            cb()
        })
    },

    /**
     * Get maximum attach upload file size
     * @return {[type]} [description]
     */
    getMaxUploadSize: () => {
        return config.get('globals').max_upload
    }
}

export default DocsModel



// WEBPACK FOOTER //
// ./src/models/DocsModel.js